import { TimelineUtils } from '../timeline.utils';

/** How the timeline maps time to the x axis of its task area. */
export interface TimelineGeometry {
  startDate: Date;
  endDate: Date;
  /** Position of the time step in `TIME_STEP_DURATION_IN_MN`. */
  stepPos: number;
  stepWidth: number;
}

export function xOfDate(g: TimelineGeometry, d: Date): number {
  return TimelineUtils.dateToStep(d, g.startDate, g.endDate, g.stepPos) * g.stepWidth;
}

export function dateOfX(g: TimelineGeometry, x: number): Date {
  return TimelineUtils.dateOfStep(x / g.stepWidth, g.startDate, g.stepPos);
}

/**
 * Rounds to the nearest multiple of `minutes` counted from the epoch. Every zone in use is offset
 * from UTC by a multiple of 15 minutes, so for 5 this lands on the site's own 5-minute marks too.
 */
export function snapToMinutes(d: Date, minutes: number): Date {
  const stepMs = minutes * 60_000;
  return new Date(Math.round(d.getTime() / stepMs) * stepMs);
}
